// BM-H398 - renders one of the copy owner's BlockCopy slots as block-level content.
//
// Heading plus one <p> per paragraph. No line-clamp, no <details>, no
// accordion, no "read more" on any viewport. Never used inside a tooltip.

import { isSentinel } from "./copySentinels";

export default function BlockCopyView({ copy, testid, role = "note" }) {
  if (!copy || isSentinel(copy)) return null;
  return (
    <section
      data-testid={testid}
      role={role}
      style={{
        border: "1px solid currentColor",
        borderRadius: 10,
        padding: "16px 18px",
        margin: "8px 0 20px",
        overflow: "visible",
      }}
    >
      <h3 data-testid={`${testid}-heading`} style={{ fontSize: 17, margin: "0 0 10px" }}>{copy.heading}</h3>
      {copy.paragraphs.map((text, i) => (
        <p key={i} data-testid={`${testid}-paragraph-${i}`} style={{ fontSize: 14, lineHeight: 1.65, margin: i === copy.paragraphs.length - 1 ? 0 : "0 0 10px" }}>
          {text}
        </p>
      ))}
    </section>
  );
}
